import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import IntroductionGalerie from "./sections/IntroductionGalerie";
import MediaGrid from "./sections/MediaGrid";
import PiedDePage from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <IntroductionGalerie />
      <MediaGrid />
      <PiedDePage />
    </div>;
}